module.exports = __webpack_public_path__ + "static/media/Dragon Tiger virtual.9d2ad903.jpg";